import React from 'react';

import { format as dateFormat } from '@eika-infrastruktur/date';
import { capitalize } from '@eika-infrastruktur/format';
import formatNumberWithCurrency from '@eika-infrastruktur/format/dist/formatNumberWithCurrency';
import { DetailsList, DetailsListItem } from '@eika/details-list';

import useAccountId from '../../hooks/useAccountId';
import { useLoanDetails } from '../../hooks/useLoans';
import { useTranslation } from '../../translations';
import { format } from '../../translations/useTranslation';

const monthYearDateFormat = 'MMMM yyyy';

const LoanDetails: React.FC = () => {
    const accountId = useAccountId();
    const { data: loan, isLoading } = useLoanDetails(accountId);
    const { loanDetails: translated } = useTranslation();
    if (!loan && !isLoading) return null;

    const initialAmount = loan && loan.balances.find((balance) => balance.type === 'INITIAL_PRINCIPAL');

    return (
        <div className="sgw-content">
            <DetailsList title={translated.title} isLoading={isLoading}>
                <DetailsListItem label={translated.name} value={loan?.productName} />
                <DetailsListItem
                    label={translated.intialAmount}
                    value={formatNumberWithCurrency(initialAmount?.amount, loan?.currency?.toString(), 0)}
                />
                <DetailsListItem
                    show={!!loan?.maturityDate}
                    label={translated.maturityDate}
                    formatter={(value) => capitalize(dateFormat(value, monthYearDateFormat))}
                    value={loan?.maturityDate}
                />
                {loan?.interestsRates.effectiveInterestRate && (
                    <DetailsListItem
                        label={translated.effectiveInterest}
                        value={`${loan?.interestsRates.effectiveInterestRate}%`}
                    />
                )}
                <DetailsListItem
                    show={!!loan?.billingSummary.paymentDueDay}
                    label={translated.paymentDate}
                    formatter={(value) => format(translated.paymentDay, value)}
                    value={loan?.billingSummary.paymentDueDay}
                />
                <DetailsListItem
                    label={translated.instalmentAmount}
                    value={formatNumberWithCurrency(loan?.instalmentAmount)}
                />
            </DetailsList>
        </div>
    );
};

export default LoanDetails;
